var React = require('react');

function Services (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .s-forms {\n        fill:#F2F2F2;\n      }\n    ")),React.createElement("path",{"id":"s_3","className":"s-forms","d":"M990.66,672c189.16-143.25,383.22-141.16,433.43,4.67s-62.43,380.18-251.59,523.43-383.23,141.16-433.44-4.67S801.49,815.24,990.66,672Z","key":1}),React.createElement("path",{"id":"s_2","className":"s-forms","d":"M517.73,222.76c230.74,217,377.4,498.12,327.58,628S568,910,337.3,693.07-40.11,195,9.72,65.07,287,5.8,517.73,222.76Z","key":2}),React.createElement("path",{"id":"s_1","className":"s-forms","d":"M755.26,1201.78c314.75,114.74,497.92,369.1,409.12,568.13s-415.94,267.36-730.69,152.62S-64.24,1553.43,24.56,1354.4,440.51,1087,755.26,1201.78Z","key":3})]);
}

Services.defaultProps = {"id":"services","data-name":"services","viewBox":"0 0 1436.04 1978.19"};

module.exports = Services;

Services.default = Services;
